<app-grid
  [rowData]="(supplierCondition$ | async) || []"
  [columnDefs]="columnDefs"
  [defaultColumnDef]="defaultColumnDef"
  [loading]="(loading$ | async) || false"></app-grid>

<pas-sidebar-holder [hasNavbar]="true">
  <div class="sidebar-contents">
    <ng-container>
      <div class="sidebar-element sidebar-row">
        <ul class="navbar-nav">
          @if (canAddAndEditSupplierCondition) {
            <li class="nav-item">
              <a (click)="addSupplierCondition()" class="nav-link link-sidebar">
                <i class="material-icons">add_circle_outline</i>
                <span class="hidden-md-down">{{ 'supplierCondition.add' | translate }}</span>
              </a>
            </li>
          }
        </ul>
      </div>
    </ng-container>
  </div>
</pas-sidebar-holder>

<ng-template #modalTemplate>
  <tur-generic-modal-content
    [acceptanceAllowed]="(isFormValidAndModalNotOpenInDisplayOnlyMode$ | async) && canAddAndEditSupplierCondition"
    (confirm)="onConfirm()"
    (cancel)="onCancel()"
    confirmationMessage=""
    modalTitle="{{ 'supplierCondition.modalTitle' | translate }}"
    acceptButtonLbl="{{ 'SAVE' | translate }}"
    cancelButtonLbl="{{ 'CANCEL' | translate }}">
    <app-supplier-condition-editor></app-supplier-condition-editor>
  </tur-generic-modal-content>
</ng-template>
